module.exports = __webpack_public_path__ + "img/wireless-bluetooth-3.239be963.png";